import { useMutation } from '@tanstack/react-query'
import { signup } from '@/services/api/auth'
import { useAuthStore } from '@/store/authStore'

const SIGNUP_MUTATION_KEY = ['mutation', 'auth', 'signup'] as const

interface SignupVars {
  username: string
  password: string
  passwordConfirmation: string
  email: string
}

/**
 * Signs up and applies the resulting session (user/token/refreshToken) to
 * `authStore`. Not offline-replayable — auth must never queue while offline.
 */
export function useSignup() {
  const setAuth = useAuthStore((s) => s.setAuth)

  return useMutation({
    mutationKey: SIGNUP_MUTATION_KEY,
    mutationFn: ({ username, password, passwordConfirmation, email }: SignupVars) =>
      signup(username, password, passwordConfirmation, email),
    onSuccess: (data) => {
      setAuth(data.user, data.token, data.refreshToken)
    },
  })
}
